export const SERVICES_FAQS_EN = [
  {
    q: "How do I choose the right Shopify service?",
    a: "Start with the constraint the business needs to resolve. Performance and CRO address customer experience; Technical SEO and GEO address discovery; Development, Apps and Shopify Plus address platform capability; Integrations and Analytics address operational data; a Retainer is appropriate when the roadmap is continuous. The services page routes each constraint to a dedicated scope.",
  },
  {
    q: "How much do Shugert engagements cost?",
    a: "Shugert publishes current project and retainer ranges on the Pricing page. The written scope explains the assumptions, affected surfaces, deliverables, exclusions and review requirements that determine the final price.",
  },
  {
    q: "Is Shugert a Shopify agency or a network of freelancers?",
    a: "Shugert is a Shopify Select Partner agency. Engagements are delivered by a senior team, with engineering, strategy and release ownership connected to the same written scope.",
  },
  {
    q: "Do you work with Shopify Plus stores?",
    a: "Yes. Shugert supports Shopify Plus work including B2B, Markets, Functions, checkout extensibility, applications, integrations and complex replatforming. Plus engagements have a dedicated commercial page because their ownership and release requirements differ from standard storefront work.",
  },
  {
    q: "Do I need to commit to a retainer?",
    a: "No. A defined problem can be handled as a fixed-scope project. A retainer is intended for teams with a continuous roadmap, recurring prioritization and ongoing release responsibility.",
  },
  {
    q: "How do you reduce production risk?",
    a: "The scope identifies environments, representative test states, acceptance criteria, release authority, rollback and monitoring. External systems and platform constraints remain dependencies, so the project documents how they are coordinated rather than claiming that risk can be eliminated.",
  },
  {
    q: "Can you inherit an existing theme, app stack or integration?",
    a: "Yes. The first step is to document the current architecture, owners, dependencies and known failure states. The team can then decide whether to extend, refactor, replace or replatform with the trade-offs visible before implementation.",
  },
  {
    q: "How is store and customer data handled?",
    a: "Access is scoped to the work being performed. Credentials, third-party accounts, source code and customer data remain client-owned, and the scope identifies any data that must move outside Shopify for an integration or application requirement.",
  },
  {
    q: "Do you bill by the hour?",
    a: "No. Bounded projects use a fixed price for the approved written scope and defined outcome. Retainers reserve ongoing senior capacity and an agreed operating cadence; they are not anonymous hourly blocks. Work outside the approved scope is estimated and approved separately before implementation.",
  },
];

export const SERVICES_FAQS_ES = [
  {
    q: "¿Cómo elijo el servicio Shopify correcto?",
    a: "Empieza con la restricción que necesita resolver el negocio. Performance y CRO cubren experiencia; SEO Técnico y GEO cubren descubrimiento; Desarrollo, Apps y Shopify Plus cubren capacidad de plataforma; Integraciones y Analítica cubren datos operativos; un Retainer aplica cuando el roadmap es continuo. La página de servicios dirige cada restricción al alcance correspondiente.",
  },
  {
    q: "¿Cuánto cuestan los engagements de Shugert?",
    a: "Shugert publica los rangos actuales de proyectos y retainers en la página de Precios. El alcance escrito explica supuestos, superficies, entregables, exclusiones y requisitos de revisión que determinan el precio final.",
  },
  {
    q: "¿Shugert es una agencia Shopify o una red de freelancers?",
    a: "Shugert es una agencia Shopify Select Partner. Los engagements son entregados por un equipo senior, con ingeniería, estrategia y ownership de release conectados al mismo alcance escrito.",
  },
  {
    q: "¿Trabajan con tiendas Shopify Plus?",
    a: "Sí. Shugert trabaja con B2B, Markets, Functions, checkout extensibility, aplicaciones, integraciones y replatforming complejo en Shopify Plus. Existe una página comercial dedicada porque el ownership y los requisitos de release son distintos.",
  },
  {
    q: "¿Tengo que comprometerme a un retainer?",
    a: "No. Un problema definido puede resolverse como proyecto de alcance fijo. El retainer está pensado para equipos con roadmap continuo, priorización recurrente y responsabilidad permanente de release.",
  },
  {
    q: "¿Cómo reducen el riesgo de producción?",
    a: "El alcance identifica ambientes, estados de prueba representativos, criterios de aceptación, autoridad de release, rollback y monitoreo. Los sistemas externos y restricciones de plataforma siguen siendo dependencias, por lo que documentamos cómo se coordinan en lugar de afirmar que el riesgo puede eliminarse.",
  },
  {
    q: "¿Pueden heredar un theme, stack de apps o integración existente?",
    a: "Sí. El primer paso es documentar arquitectura, owners, dependencias y fallos conocidos. Después se decide si conviene extender, refactorizar, reemplazar o replatformar con los trade-offs visibles antes de implementar.",
  },
  {
    q: "¿Cómo manejan los datos de la tienda y de clientes?",
    a: "El acceso se limita al trabajo contratado. Credenciales, cuentas de terceros, código fuente y datos permanecen bajo propiedad del cliente, y el alcance identifica cualquier dato que deba salir de Shopify por una integración o aplicación.",
  },
  {
    q: "¿Facturan por hora?",
    a: "No. Los proyectos acotados tienen un precio fijo para el alcance escrito aprobado y el resultado definido. Los retainers reservan capacidad senior continua y una cadencia acordada; no son bolsas anónimas de horas. El trabajo fuera del alcance aprobado se cotiza y autoriza por separado antes de implementarse.",
  },
];
